import React from 'react';
import {IntlProvider, FormattedMessage} from 'react-intl';
import {enUSmessage} from 'i18n/en-US.js';

export default {
  fields: [
    {
      type: 'text',
      name: 'amount',
      props: {
        required: true,
        label: (
          <p>
            <i className='asterisk icon inline' />
            <IntlProvider locale='en' messages={enUSmessage}>
              <FormattedMessage id='userManagement.userDetail.modals.awardDays.amount' />
            </IntlProvider>
          </p>
        )
      }
    }
  ]
};



// WEBPACK FOOTER //
// ./public/pages/UserManagement/UserDetailPage/modals/AwardDaysModal/awardDaysFormConfig.jsx